import { Pipe, PipeTransform } from "@angular/core";
import { printAddress, printContactAddress } from "src/app/utility/pretty-string";

@Pipe({
    name: "printAddress",
    standalone: false,
})
export class PrintAddressPipe implements PipeTransform {
    transform(value: string | object | null, type: string = "address") {
        if (typeof value === "string" || value instanceof String || !value) {
            return value;
        }

        if (type === "contact") {
            return printContactAddress(value);
        }
        return printAddress(value);
    }
}
